import { Button } from '@/components/ui/button';
import { Cookie, Settings, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useConsent } from './ConsentContext';

export default function ConsentBanner() {
  const { showBanner, setShowSettings, acceptAll, acceptNecessaryOnly } = useConsent();

  if (!showBanner) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-0 left-0 right-0 z-[9999] p-4 bg-white border-t border-gray-200 shadow-2xl"
        data-testid="consent-banner"
      >
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4">
            <div className="flex items-start gap-3 flex-1">
              <div className="p-2 bg-[#006847]/10 rounded-full flex-shrink-0">
                <Cookie className="h-6 w-6 text-[#006847]" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">We value your privacy</h3>
                <p className="text-sm text-gray-600 mt-1">
                  We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic.
                  By clicking "Accept All", you consent to our use of cookies.
                  <Link to="/privacy-policy" className="text-[#006847] hover:underline ml-1">
                    Privacy Policy
                  </Link>
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 w-full lg:w-auto">
              <Button variant="outline" size="sm" onClick={() => setShowSettings(true)} className="flex-1 lg:flex-none">
                <Settings className="h-4 w-4 mr-2" /> Customize
              </Button>
              <Button variant="outline" size="sm" onClick={acceptNecessaryOnly} className="flex-1 lg:flex-none border-gray-300">
                Reject All
              </Button>
              <Button size="sm" onClick={acceptAll} className="flex-1 lg:flex-none bg-[#006847] hover:bg-[#005538]">
                <Check className="h-4 w-4 mr-2" /> Accept All
              </Button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
